import { deriveRows } from "../components/salepoint/SaleTable";

function transformTransaction(tx) {
  const errors = [];
  const items = [];

  const toNumber = (v) => {
    if (v === "" || v === null || v === undefined) return 0;
    const n = Number(v);
    return isNaN(n) ? 0 : n;
  };

  // CASH
  if (tx.cash?.amount) {
    const amount = toNumber(tx.cash.amount);

    if (amount <= 0) {
      errors.push("Cash amount must be greater than 0");
    } else {
      items.push({
        type: "cash",
        currency: tx.cash.currency,
        totalAmount: amount,
      });
    }
  }

  // PC
  if (tx.pc?.qty || tx.pc?.rate?.rate) {
    const qty = toNumber(tx.pc.qty);
    const rate = toNumber(tx.pc.rate?.rate);

    if (!tx.pc.brand) {
      errors.push("PC brand is required");
    }

    if (qty <= 0) {
      errors.push("PC quantity must be greater than 0");
    }

    items.push({
      type: "pc",
      brand: tx.pc.brand,
      qty,
      totalWeight: toNumber(tx.pc.totalWeight),
      diff: toNumber(tx.pc.diff),
      diffAmount: toNumber(tx.pc.diffAmount),
      rate,
      totalAmount: toNumber(tx.pc.rate?.totalAmount),
      rw: tx.pc.rw,
      postDate: tx.pc.postDate || null,
    });
  }

  // BAR
  if (tx.bar?.qty || tx.bar?.weight) {
    items.push({
      type: "bar",
      brand: tx.bar.brand,
      qty: toNumber(tx.bar.qty),
      weight: toNumber(tx.bar.totalWeight),
      making: toNumber(tx.bar.making),
      diff: toNumber(tx.bar.diff),
      totalAmount: toNumber(tx.bar.totalAmount),
      rate: toNumber(tx.bar.rate?.rate),
    });
  }

  // COIN
  if (tx.coin?.qty || tx.coin?.weight) {
    items.push({
      type: "coin",
      brand: tx.coin.brand,
      karat: tx.coin.karat,
      qty: toNumber(tx.coin.qty),
      weight: toNumber(tx.coin.totalWeight),
      pureWeight: toNumber(tx.coin.pureWeight),
      totalAmount: toNumber(tx.coin.totalAmount),
      rate: toNumber(tx.coin.rate?.rate),
    });
  }

  // GINNI
  if (tx.ginni?.weight || tx.ginni?.pureWeight) {
    items.push({
      type: "ginni",
      weight: toNumber(tx.ginni.weight),
      pureWeight: toNumber(tx.ginni.pureWeight),
      refineAmount: toNumber(tx.ginni.refineAmount),
      refineCharges: toNumber(tx.ginni.refineCharges),
      totalAmount: toNumber(tx.ginni.totalAmount),
    });
  }

  // GOLD RATE WORK
  if (tx.goldRW?.weight) {
    items.push({
      type: "goldRW",
      weight: toNumber(tx.goldRW.weight),
      rate: toNumber(tx.goldRW.rate),
      diff: toNumber(tx.goldRW.diff),
      amount: toNumber(tx.goldRW.amount),
      totalAmount: toNumber(tx.goldRW.totalAmount),
      rw: tx.goldRW.rw,
      postDate: tx.goldRW.postDate,
    });
  }

  // SILVER RATE WORK
  if (tx.silverRW?.weight) {
    items.push({
      type: "silverRW",
      weight: toNumber(tx.silverRW.weight),
      rate: toNumber(tx.silverRW.rate),
      diff: toNumber(tx.silverRW.diff),
      amount: toNumber(tx.silverRW.amount),
      totalAmount: toNumber(tx.silverRW.totalAmount),
      rw: tx.silverRW.rw,
      postDate: tx.silverRW.postDate,
    });
  }

  return {
    type: tx.type,
    items,
    errors,
  };
}

export function tranformTransactions({ receiveTx, givenTx }) {
  const receiveItems = transformTransaction(receiveTx);
  const givenItems = transformTransaction(givenTx);

  return {
    receiveItems: receiveItems.items,
    givenItems: givenItems.items,
    errors: [...receiveItems.errors, ...givenItems.errors],
  };
}

export function transactionRequest({ customerId, receiveTx, givenTx, note }) {
  const receiveData = transformTransaction(receiveTx);
  const givenData = transformTransaction(givenTx);
  if (receiveData.errors.length || givenData.errors.length) {
    return {
      sucess: false,
      errors: [...receiveData.errors, ...givenData.errors],
    };
  }
  return {
    sucess: true,
    data: {
      customerId,
      givenItems: givenData.items,
      receivedItems: receiveData.items,
      note,
    },
  };
}

export const transactionRequestUpdated = ({
  customerId,
  receiveTx,
  givenTx,
  note = "",
}) => {
  const errors = [];

  // helper to clean arrays
  const cleanArray = (arr = [], mapper) =>
    arr.map(mapper).filter((item) => item && Object.keys(item));

  // ─── CASH ─────────────────────────────
  const receiveCash = Number(receiveTx?.cash?.amount || 0);
  const givenCash = Number(givenTx?.cash?.amount || 0);

  // ─── PC ───────────────────────────────
  const mapPC = (item) => {
    if (!item.weight || item.weight <= 0) return null;

    const weight = Number(item.weight);
    const rate = Number(item.rate || 0);
    const amount = rate > 0 ? weight * rate : Number(item.amount || 0);

    return {
      brand: item.brand || "GENERIC",
      weight,
      ...(rate > 0 && { rate }),
      ...(amount > 0 && { amount }),
    };
  };

  const receivePC = cleanArray(receiveTx?.pc?.items || [], mapPC);
  const givenPC = cleanArray(givenTx?.pc?.items || [], mapPC);

  // ─── VALIDATION ───────────────────────
  if (!customerId) errors.push("Customer is required");

  const hasData = receiveCash > 0 || givenCash > 0 || receivePC || givenPC;

  if (!hasData) {
    errors.push("At least one transaction item is required");
  }

  if (errors) {
    return { success: false, errors };
  }

  // ─── FINAL PAYLOAD ────────────────────
  const data = {
    customerId,
    note,

    receive: {
      cash: { amount: receiveCash },
      pc: receivePC,
    },

    given: {
      cash: { amount: givenCash },
      pc: givenPC,
    },
  };

  return {
    success: true,
    data,
  };
};

// export const myTransactionRequest = ({
//   customerId,
//   receiveTx,
//   givenTx,
//   note = "",
// }) => {
//   const errors = [];

//   // ─────────────────────────────
//   // HELPERS
//   // ─────────────────────────────

//   const num = (val) => Number(val || 0);

//   // ─────────────────────────────
//   // CASH
//   // ─────────────────────────────

//   const receiveCash = num(receiveTx?.cash?.amount);
//   const givenCash = num(givenTx?.cash?.amount);

//   // ─────────────────────────────
//   // PC (🔥 MAIN SECTION)
//   // ─────────────────────────────

//   const mapPC = (pc) => {
//     if (!pc) return [];

//     const weight = num(pc.totalWeight || pc.weight);
//     const rate = num(pc.rate?.rate);
//     const amount =
//       rate > 0 ? weight * rate : num(pc.rate?.amount || pc.diffAmount);

//     if (weight <= 0) return [];

//     return [
//       {
//         brand: pc.brand || "GENERIC",
//         weight,
//         ...(rate > 0 && { rate }),
//         ...(amount > 0 && { amount }),
//       },
//     ];
//   };

//   const receivePC = mapPC(receiveTx?.pc);
//   const givenPC = mapPC(givenTx?.pc);

//   // ─────────────────────────────
//   // LAB
//   // ─────────────────────────────

//   const mapLab = (lab) => {
//     if (!lab) return [];

//     const weight = num(lab.weight || lab.pureWeight);
//     if (weight <= 0) return [];

//     return [{ weight }];
//   };

//   const receiveLab = mapLab(receiveTx?.lab);
//   const givenLab = mapLab(givenTx?.lab);

//   // ─────────────────────────────
//   // BAR
//   // ─────────────────────────────

//   const mapBar = (bar) => {
//     if (!bar) return [];

//     const weight = num(bar.totalWeight || bar.weight);
//     if (weight <= 0) return [];

//     return [
//       {
//         brand: bar.brand || "GENERIC",
//         weight,
//       },
//     ];
//   };

//   const receiveBar = mapBar(receiveTx?.bar);
//   const givenBar = mapBar(givenTx?.bar);

//   // ─────────────────────────────
//   // COIN
//   // ─────────────────────────────

//   const mapCoin = (coin) => {
//     if (!coin) return [];

//     const weight = num(coin.totalWeight || coin.weight);
//     if (weight <= 0) return [];

//     return [
//       {
//         brand: coin.brand || "GENERIC",
//         weight,
//       },
//     ];
//   };

//   const receiveCoin = mapCoin(receiveTx?.coin);
//   const givenCoin = mapCoin(givenTx?.coin);

//   // ─────────────────────────────
//   // GINNI
//   // ─────────────────────────────

//   const mapGinni = (ginni) => {
//     if (!ginni) return [];

//     const weight = num(ginni.totalWeight || ginni.weight);
//     if (weight <= 0) return [];

//     return [{ weight }];
//   };

//   const receiveGinni = mapGinni(receiveTx?.ginni);
//   const givenGinni = mapGinni(givenTx?.ginni);

//   // ─────────────────────────────
//   // SILVER
//   // ─────────────────────────────

//   const mapSilver = (silver) => {
//     if (!silver) return [];

//     const weight = num(silver.totalWeight || silver.barWeight);
//     if (weight <= 0) return [];

//     return [
//       {
//         brand: silver.brand || "GENERIC",
//         weight,
//       },
//     ];
//   };

//   const receiveSilver = mapSilver(receiveTx?.silver);
//   const givenSilver = mapSilver(givenTx?.silver);

//   // ─────────────────────────────
//   // RATE WORK (GOLD / SILVER)
//   // ─────────────────────────────

//   const mapRateWork = (rw) => {
//     if (!rw) return null;

//     const weight = num(rw.weight);
//     const rate = num(rw.rate);

//     if (weight <= 0 || rate <= 0) return null;

//     const amount = weight * rate;
//     const diff = num(rw.diff);
//     const totalAmount = amount - diff;

//     return {
//       weight,
//       rate,
//       amount,
//       diff,
//       totalAmount,
//       status: rw.status || "pending",
//     };
//   };

//   const receiveGoldRW = mapRateWork(receiveTx?.goldRW);
//   const givenGoldRW = mapRateWork(givenTx?.goldRW);

//   const receiveSilverRW = mapRateWork(receiveTx?.silverRW);
//   const givenSilverRW = mapRateWork(givenTx?.silverRW);

//   // ─────────────────────────────
//   // VALIDATION
//   // ─────────────────────────────

//   if (!customerId) {
//     errors.push("Customer is required");
//   }

//   const hasData =
//     receiveCash > 0 ||
//     givenCash > 0 ||
//     receivePC ||
//     givenPC ||
//     receiveLab ||
//     givenLab;

//   if (!hasData) {
//     errors.push("At least one transaction item is required");
//   }

//   if (errors) {
//     return { success: false, errors };
//   }

//   // ─────────────────────────────
//   // FINAL PAYLOAD
//   // ─────────────────────────────

//   const data = {
//     customerId,
//     note,

//     receive: {
//       cash: { amount: receiveCash },
//       pc: receivePC,
//       lab: receiveLab,
//       bar: receiveBar,
//       coin: receiveCoin,
//       ginni: receiveGinni,
//       silver: receiveSilver,
//       goldRateWork: receiveGoldRW,
//       silverRateWork: receiveSilverRW,
//     },

//     given: {
//       cash: { amount: givenCash },
//       pc: givenPC,
//       lab: givenLab,
//       bar: givenBar,
//       coin: givenCoin,
//       ginni: givenGinni,
//       silver: givenSilver,
//       goldRateWork: givenGoldRW,
//       silverRateWork: givenSilverRW,
//     },
//   };

//   return {
//     success: true,
//     data,
//   };
// };

export const myTransactionRequest = ({
  customerId,
  serialNumber,
  receiveTx,
  givenTx,
  note = "",
}) => {
  const errors = [];

  // ─────────────────────────────
  // CASH
  // ─────────────────────────────

  const mapCash = (cash) => {
    if (cash?.amount) {
      return { amount: num(cash?.amount) };
    } else null;
  };

  // ─────────────────────────────
  // PC (NO CALCULATION)
  // ─────────────────────────────

  const mapPC = (pc) => {
    if (!pc) return null;

    const isValidPC = pc.totalWeight || pc.rate?.weight;

    if (!isValidPC) return null;

    const requiredObject = {
      brand: pc.brand?.toLowerCase() === "select" ? "Not Selected" : pc.brand,
      weight: num(pc.totalWeight),
      amount: num(pc.totalAmount),
      qty: num(pc.qty),
    };

    if (pc?.rate?.rate) {
      requiredObject.isRateApplied = true;
      requiredObject.amount = num(pc?.rate.totalAmount);
      requiredObject.weight = num(pc?.rate?.weight);
    }

    return requiredObject;
  };

  // ─────────────────────────────
  // LAB
  // ─────────────────────────────

  const mapLab = (lab) => {
    if (!lab) return null;

    if (!lab.weight || !lab.pureWeight) return null;

    const rquiredObject = {
      report: num(lab.report),
      weight: num(lab.weight),
      pureWeight: num(lab.pureWeight),
      totalAmount: num(lab.totalAmount),
      testingFeesPW: num(lab.testingPw),
      testingFeesOA: num(lab.testingOa),
      isRateApplied: false,
    };

    if (lab.rate?.rate) {
      rquiredObject.isRateApplied = true;
      rquiredObject.totalAmount = num(lab.rate?.totalAmount);
      rquiredObject.rate = num(lab.rate.rate);
    }

    return rquiredObject;
  };

  // ─────────────────────────────
  // BAR
  // ─────────────────────────────

  const mapBar = (bar) => {
    if (!bar) return null;

    if (!bar.weight || !bar.totalWeight) return null;

    const requiredObject = {
      brand: bar.brand,
      barWeight: num(bar.weight),
      qty: num(bar.qty),
      making: num(bar.making),
      totalMaking: num(bar.totalMaking),

      isRateApplied: false,
      totalWeight: num(bar.totalWeight),
      totalAmount: num(bar.totalAmount),
      discount: num(bar.discount),
    };

    if (bar.rate?.rate) {
      requiredObject.isRateApplied = true;
      requiredObject.rate = num(bar.rate.rate);
      requiredObject.totalWeight = num(bar.rate.weight);
      requiredObject.totalAmount = num(bar.rate.totalAmount);
    }

    return requiredObject;
  };

  // ─────────────────────────────
  // COIN
  // ─────────────────────────────

  const mapCoin = (coin) => {
    if (!coin) return null;

    if (!coin.weight || !coin.totalWeight) return null;

    const requiredObject = {
      brand: coin.brand,
      coinWeight: num(coin.weight),
      qty: num(coin?.qty),

      making: num(coin?.making),

      karat: num(coin?.karat),
      isRateApplied: false,
      totalWeight: num(coin?.totalWeight),
      totalAmount: num(coin?.totalAmount),

      pureWeight: num(coin?.pureWeight),
    };

    if (coin?.rate?.rate) {
      requiredObject.isRateApplied = true;
      requiredObject.totalAmount = num(coin?.rate?.totalAmount);
      requiredObject.pureWeight = num(coin?.rate?.weight);
      requiredObject.rate = num(coin.rate.rate);
    }

    return requiredObject;
  };

  // ─────────────────────────────
  // GINNI
  // ─────────────────────────────

  const mapGinni = (ginni) => {
    if (!ginni) return null;

    if (!ginni.weight || !ginni.totalWeight) return null;

    const requiredObject = {
      ginniWeight: num(ginni.weight),
      qty: 0,

      refineAmount: num(ginni.refineAmount),
      refineCharges: num(ginni.refineCharges),
      report: num(ginni.report),

      isRateApplied: false,
      pureWeight: num(ginni.pureWeight),
      totalAmount: num(ginni.totalAmount),
      totalWeight: num(ginni.totalWeight),
    };

    if (ginni.rate?.rate) {
      requiredObject.isRateApplied = true;
      requiredObject.totalAmount = num(ginni?.rate?.totalAmount);
      requiredObject.pureWeight = num(ginni?.rate?.weight);
      requiredObject.rate = num(ginni.rate.rate);
    }

    return requiredObject;
  };

  // ─────────────────────────────
  // SILVER
  // ─────────────────────────────

  const mapSilver = (silver) => {
    if (!silver) return null;

    if (!silver?.barWeight || !silver?.totalWeight) return null;

    const requiredObject = {
      brand: silver?.brand,
      barWeight: num(silver.barWeight),
      rawalRod: num(silver?.rawal),
      qty: num(silver.qty || 1),
      making: num(silver.making),
      isRateApplied: false,
      totalWeight: num(silver?.totalWeight),
      totalAmount: num(silver?.totalAmount),
    };

    if (silver?.rate?.rate) {
      requiredObject.isRateApplied = true;
      requiredObject.totalAmount = num(silver?.rate?.totalAmount);
      requiredObject.pureWeight = num(silver?.rate?.weight);
      requiredObject.rate = num(silver.rate.rate);
    }

    return requiredObject;
  };

  // ─────────────────────────────
  // RATE WORK (NO CALCULATION)
  // ─────────────────────────────

  const mapRateWork = (rw) => {
    if (!rw) return null;

    const weight = num(rw.weight);
    if (weight <= 0) return null;

    return {
      weight,
      ...(rw.rate && { rate: num(rw.rate) }),
      ...(rw.amount && { amount: num(rw.amount) }),
      ...(rw.diff && { diff: num(rw.diff) }),
      ...(rw.totalAmount && { totalAmount: num(rw.totalAmount) }),
      ...(rw.status && { status: rw.status }),
    };
  };

  // ─────────────────────────────
  // BUILD DATA
  // ─────────────────────────────

  const r_cash = mapCash(receiveTx?.cash);
  const r_pc = mapPC(receiveTx?.pc);
  const r_lab = mapLab(receiveTx?.lab);
  const r_bar = mapBar(receiveTx?.bar);
  const r_coin = mapCoin(receiveTx?.coin);
  const r_ginni = mapGinni(receiveTx?.ginni);
  const r_silver = mapSilver(receiveTx?.silver);
  const r_goldRateWork = mapRateWork(receiveTx?.goldRW);
  const r_silverRateWork = mapRateWork(receiveTx?.silverRW);

  const g_cash = mapCash(givenTx?.cash);
  const g_pc = mapPC(givenTx?.pc);
  const g_lab = mapLab(givenTx?.lab);
  const g_bar = mapBar(givenTx?.bar);
  const g_coin = mapCoin(givenTx?.coin);
  const g_ginni = mapGinni(givenTx?.ginni);
  const g_silver = mapSilver(givenTx?.silver);
  const g_goldRateWork = mapRateWork(givenTx?.goldRW);
  const g_silverRateWork = mapRateWork(givenTx?.silverRW);

  const data = {
    customerId,
    serialNumber,
    note,

    receive: {
      ...(r_cash != null && { cash: r_cash }),
      ...(r_pc != null && { pc: r_pc }),
      ...(r_lab != null && { lab: r_lab }),
      ...(r_bar != null && { bar: r_bar }),
      ...(r_coin != null && { coin: r_coin }),
      ...(r_ginni != null && { ginni: r_ginni }),
      ...(r_silver != null && { silver: r_silver }),
      ...(r_goldRateWork != null && { goldRateWork: r_goldRateWork }),
      ...(r_silverRateWork != null && { silverRateWork: r_silverRateWork }),
    },

    given: {
      ...(g_cash != null && { cash: g_cash }),
      ...(g_pc != null && { pc: g_pc }),
      ...(g_lab != null && { lab: g_lab }),
      ...(g_bar != null && { bar: g_bar }),
      ...(g_coin != null && { coin: g_coin }),
      ...(g_ginni != null && { ginni: g_ginni }),
      ...(g_silver != null && { silver: g_silver }),
      ...(g_goldRateWork != null && { goldRateWork: g_goldRateWork }),
      ...(g_silverRateWork != null && { silverRateWork: g_silverRateWork }),
    },
  };

  // ─────────────────────────────
  // VALIDATION
  // ─────────────────────────────

  const hasData =
    // check cash amounts
    data.receive.cash?.amount > 0 ||
    data.given.cash?.amount > 0 ||
    // check pc
    !!data.receive.pc ||
    !!data.given.pc ||
    // check lab
    !!data.receive.lab ||
    !!data.given.lab ||
    // check bar
    !!data.receive.bar ||
    !!data.given.bar ||
    // check coin
    !!data.receive.coin ||
    !!data.given.coin ||
    // check ginni
    !!data.receive.ginni ||
    !!data.given.ginni ||
    // check silver
    !!data.receive.silver ||
    !!data.given.silver ||
    !!data.receive.goldRateWork ||
    !!data.given.goldRateWork ||
    !!data.receive.silverRateWork ||
    !!data.given.silverRateWork;

  const generateAutoNote = () => {
    const parts = [];

    const pushIf = (condition, text) => {
      if (condition) parts.push(text);
    };

    // ─── RECEIVE ───────────
    pushIf(r_cash?.amount > 0, "Cash received");
    pushIf(r_pc, "PC received");
    pushIf(r_lab, "Lab received");
    pushIf(r_bar, "Bar received");
    pushIf(r_coin, "Coin received");
    pushIf(r_ginni, "Ginni received");
    pushIf(r_silver, "Silver received");
    pushIf(r_goldRateWork, "Gold RW received");
    pushIf(r_silverRateWork, "Silver RW received");

    // ─── GIVEN ───────────
    pushIf(g_cash?.amount > 0, "Cash given");
    pushIf(g_pc, "PC given");
    pushIf(g_lab, "Lab given");
    pushIf(g_bar, "Bar given");
    pushIf(g_coin, "Coin given");
    pushIf(g_ginni, "Ginni given");
    pushIf(g_silver, "Silver given");
    pushIf(g_goldRateWork, "Gold RW given");
    pushIf(g_silverRateWork, "Silver RW given");

    if (parts.length === 0) return "";

    return parts.join(" | ");
  };

  data.note = generateAutoNote();

  if (!customerId) {
    errors.push("Customer is required");
  }

  if (!hasData) {
    errors.push("At least one transaction item is required");
  }

  if (errors && errors.length > 0) {
    return { success: false, errors };
  }

  return {
    success: true,
    data,
  };
};
const num = (val) => Number(val || 0);

export const myTransactionRequestUpdpatedOld = ({
  customerId,
  serialNumber,
  receiveTx,
  givenTx,
  note = "",
}) => {
  const errors = [];
  const num = (val) => Number(val || 0);

  const mapCash = (cash) => {
    if (!cash?.amount) return null;
    return { amount: num(cash.amount) };
  };

  const mapPC = (pc) => {
    if (!pc) return null;
    const isValid = pc.totalWeight || pc.rate?.weight;
    if (!isValid) return null;

    const isRateApplied = !!pc?.rate?.rate;
    const netWeight = isRateApplied ? num(pc.rate.weight) : num(pc.totalWeight);
    // const netAmount = isRateApplied ? num(pc.rate.totalAmount) : 0;
    const diff = num(pc.diff || 0);
    const diffAmount = num(pc.totalAmount || 0);

    const isResultBrand = isBrandSelected(pc, "pc");
    if (!isResultBrand) {
      errors.push(`PC brand is required`);
    }

    const paidAmount = num(pc.paidAmount || 0);
    return {
      brand: pc.brand,
      weight: num(pc.totalWeight),
      qty: num(pc.qty),
      isRateApplied,
      rate: getRateOfWork(pc, isRateApplied),
      diff,
      diffAmount,
      paidAmount,
      netWeight,
      netAmount: diffAmount,
    };
  };

  const mapLab = (lab) => {
    if (!lab?.weight) return null;
    // Allow saving without report (report = null)
    const isRateApplied = !!lab.rate?.rate;
    const netWeight = num(lab.pureWeight); // 0 if no report yet
    const netAmount = isRateApplied
      ? num(lab.rate.totalAmount)
      : num(lab?.totalAmount);

    const paidAmount = num(lab.paidAmount || 0);
    return {
      report: lab.report ? num(lab.report) : null,
      weight: num(lab.weight),
      pureWeight: num(lab.pureWeight),
      diff: num(lab.diff),
      diffAmount: num(lab.diffAmount),
      totalAmount: isRateApplied
        ? num(lab.rate.totalAmount)
        : num(lab.totalAmount),
      testingFeesPW: num(lab.testingPw),
      testingFeesOA: num(lab.testingOa),
      testingOaQty: num(lab.testingOaQty) || 1,
      isRateApplied,
      rate: getRateOfWork(lab, isRateApplied),
      paidAmount,
      resendReport: lab?.resendReport || false,
      netWeight,
      netAmount,
    };
  };

  const mapBar = (bar) => {
    if (!bar?.weight || !bar?.totalWeight) return null;
    const isRateApplied = !!bar.rate?.rate;
    const netWeight = isRateApplied
      ? num(bar.rate.weight)
      : num(bar.totalWeight);
    // const netAmount = isRateApplied ? num(bar.rate.totalAmount) : 0;

    const diff = num(bar.diff || 0);
    const netAmount = num(bar.totalAmount);

    const isResultBrand = isBrandSelected(bar, "bar");
    if (!isResultBrand) {
      errors.push(`Bar brand is required`);
    }

    const paidAmount = num(bar.paidAmount || 0);
    return {
      brand: bar.brand,
      barWeight: num(bar.weight),
      qty: num(bar.qty),
      making: num(bar.making),
      totalMaking: num(bar.makingTotal),
      isRateApplied,
      rate: getRateOfWork(bar, isRateApplied),
      totalWeight: num(bar.totalWeight),
      totalAmount: num(bar.totalAmount),
      discount: num(bar.discount),
      paidAmount,
      diff,
      netWeight,
      netAmount,
    };
  };

  const mapCoin = (coin) => {
    if (!coin?.weight || !coin?.totalWeight) return null;
    const isRateApplied = !!coin.rate?.rate;
    const netWeight = isRateApplied
      ? num(coin.rate.weight)
      : num(coin.pureWeight || coin.totalWeight);
    // const netAmount = isRateApplied ? num(coin.rate.totalAmount) : 0;
    const diff = num(coin.diff || 0);
    const netAmount = num(coin.totalAmount);

    const isResultBrand = isBrandSelected(coin, "coin");
    if (!isResultBrand) {
      errors.push(`Coin brand is required`);
    }

    const paidAmount = num(coin.paidAmount || 0);
    return {
      brand: coin.brand,
      coinWeight: num(coin.weight),
      qty: num(coin.qty),
      making: num(coin.making),
      karat: num(coin.karat),
      isRateApplied,
      rate: getRateOfWork(coin, isRateApplied),
      totalWeight: num(coin.totalWeight),
      pureWeight: num(coin.pureWeight),
      totalAmount: num(coin.totalAmount),
      diff,
      paidAmount,
      netWeight,
      netAmount,
    };
  };

  const mapGinni = (ginni) => {
    if (!ginni?.weight || !ginni?.totalWeight) return null;
    const isRateApplied = !!ginni.rate?.rate;
    const netWeight = isRateApplied
      ? num(ginni.rate.weight)
      : num(ginni.pureWeight);
    // const netAmount = isRateApplied ? num(ginni.rate.totalAmount) : 0;
    const netAmount = num(ginni.totalAmount || 0);
    const paidAmount = num(ginni.paidAmount || 0);

    return {
      ginniWeight: num(ginni.weight),
      qty: 0,
      refineAmount: num(ginni.refineAmount),
      refineCharges: num(ginni.refineCharges),
      report: ginni.report ? num(ginni.report) : null,
      isRateApplied,
      rate: getRateOfWork(ginni, isRateApplied),
      pureWeight: num(ginni.pureWeight),
      totalAmount: num(ginni.totalAmount),
      totalWeight: num(ginni.totalWeight),
      resendReport: ginni?.resendReport || false,
      paidAmount,
      netWeight,
      netAmount,
    };
  };

  const mapSilver = (silver) => {
    if (!silver?.totalWeight) return null;
    const isRateApplied = !!silver.rate?.rate;
    const netWeight = isRateApplied
      ? num(silver.rate.weight)
      : num(silver.totalWeight);
    // const netAmount = isRateApplied ? num(silver.rate.totalAmount) : 0;
    const netAmount = num(silver.totalAmount || 0);

    const isResultBrand = isBrandSelected(silver, "silver");
    if (!isResultBrand) {
      errors.push(`Silver brand is required`);
    }
    const paidAmount = num(silver.paidAmount || 0);
    return {
      brand: silver.brand,
      barWeight: num(silver.barWeight),
      rawalRod: num(silver.rawal),
      qty: num(silver.qty || 1),
      making: num(silver.making),
      isRateApplied,
      rate: getRateOfWork(silver, isRateApplied),
      totalWeight: num(silver.totalWeight),
      totalAmount: num(silver.totalAmount),
      paidAmount,
      netWeight,
      netAmount,
    };
  };

  const mapRateWork = (rw) => {
    if (!rw) return null;
    const weight = num(rw.weight);
    const rate = num(rw.rate);
    if (weight <= 0 || rate <= 0) {
      return null;
    }

    const netAmount = num(rw.totalAmount);
    const netWeight = num(rw.weight);

    //Here i need to check as:
    //status is r then, transaction is completed
    // if status is w, then transaction will be completed after 1 week.
    // if postDate is selected, then, on that date the order will be completed(tx)
    const today = new Date();

    const isCompleted = rw.status === "D&L";
    const completionDate = rw.postDate ? new Date(rw.postDate) : today;

    return {
      weight,
      ...(rw.rate && { rate: num(rw.rate) }),
      ...(rw.amount && { amount: num(rw.amount) }),
      ...(rw.diff && { diff: num(rw.diff) }),
      ...(rw.totalAmount && { totalAmount: num(rw.totalAmount) }),
      ...(rw.status && { status: rw.status }),
      netAmount,
      netWeight,
      postDate: completionDate,
      status: isCompleted ? "D&L" : "Pending",
      isRateApplied: true,
    };
  };
  // const mapRateWork = (rw) => {
  //   if (!rw) return null;
  //   const weight = num(rw.weight);
  //   const rate = num(rw.rate);
  //   if (weight <= 0 || rate <= 0) {
  //     return null;
  //   }

  //   const netAmount = num(rw.totalAmount);
  //   const netWeight = num(rw.weight);

  //   //Here i need to check as:
  //   //status is r then, transaction is completed
  //   // if status is w, then transaction will be completed after 1 week.
  //   // if postDate is selected, then, on that date the order will be completed(tx)
  //   const today = new Date();

  //   let completionDate = null;
  //   let isCompleted = false;

  //   // 🔥 PRIORITY 1: postDate
  //   if (rw.postDate) {
  //     completionDate = new Date(rw.postDate);

  //     // check if already completed
  //     if (completionDate <= today) {
  //       isCompleted = true;
  //     }
  //   }

  //   // 🔥 PRIORITY 2: status = "r" (ready)
  //   else if (rw.rw === "R") {
  //     completionDate = today;
  //     isCompleted = true;
  //   }

  //   // 🔥 PRIORITY 3: status = "w" (waiting 7 days)
  //   else if (rw.rw === "W") {
  //     completionDate = new Date();
  //     completionDate.setDate(completionDate.getDate() + 7);

  //     // not completed yet
  //     isCompleted = false;
  //   }
  //   return {
  //     weight,
  //     ...(rw.rate && { rate: num(rw.rate) }),
  //     ...(rw.amount && { amount: num(rw.amount) }),
  //     ...(rw.diff && { diff: num(rw.diff) }),
  //     ...(rw.totalAmount && { totalAmount: num(rw.totalAmount) }),
  //     ...(rw.status && { status: rw.status }),
  //     netAmount,
  //     netWeight,
  //     postDate: completionDate,
  //     status: isCompleted ? "D&L" : "Pending",
  //     isRateApplied: true,
  //   };
  // };

  // ── Build & rest of function stays same ──────────────────────────────────
  // ... (validation and note generation unchanged)
  const r_cash = mapCash(receiveTx?.cash);
  const r_pc = mapPC(receiveTx?.pc);
  const r_lab = mapLab(receiveTx?.lab);
  const r_bar = mapBar(receiveTx?.bar);
  const r_coin = mapCoin(receiveTx?.coin);
  const r_ginni = mapGinni(receiveTx?.ginni);
  const r_silver = mapSilver(receiveTx?.silver);
  const r_goldRateWork = mapRateWork(receiveTx?.goldRW);
  const r_silverRateWork = mapRateWork(receiveTx?.silverRW);

  const g_cash = mapCash(givenTx?.cash);
  const g_pc = mapPC(givenTx?.pc);
  const g_lab = mapLab(givenTx?.lab);
  const g_bar = mapBar(givenTx?.bar);
  const g_coin = mapCoin(givenTx?.coin);
  const g_ginni = mapGinni(givenTx?.ginni);
  const g_silver = mapSilver(givenTx?.silver);
  const g_goldRateWork = mapRateWork(givenTx?.goldRW);
  const g_silverRateWork = mapRateWork(givenTx?.silverRW);

  const data = {
    customerId,
    serialNumber,
    note,

    receive: {
      ...(r_cash != null && { cash: r_cash }),
      ...(r_pc != null && { pc: r_pc }),
      ...(r_lab != null && { lab: r_lab }),
      ...(r_bar != null && { bar: r_bar }),
      ...(r_coin != null && { coin: r_coin }),
      ...(r_ginni != null && { ginni: r_ginni }),
      ...(r_silver != null && { silver: r_silver }),
      ...(r_goldRateWork != null && { goldRateWork: r_goldRateWork }),
      ...(r_silverRateWork != null && { silverRateWork: r_silverRateWork }),
    },

    given: {
      ...(g_cash != null && { cash: g_cash }),
      ...(g_pc != null && { pc: g_pc }),
      ...(g_lab != null && { lab: g_lab }),
      ...(g_bar != null && { bar: g_bar }),
      ...(g_coin != null && { coin: g_coin }),
      ...(g_ginni != null && { ginni: g_ginni }),
      ...(g_silver != null && { silver: g_silver }),
      ...(g_goldRateWork != null && { goldRateWork: g_goldRateWork }),
      ...(g_silverRateWork != null && { silverRateWork: g_silverRateWork }),
    },
  };

  // ─────────────────────────────
  // VALIDATION
  // ─────────────────────────────

  const hasData =
    // check cash amounts
    data.receive.cash?.amount > 0 ||
    data.given.cash?.amount > 0 ||
    // check pc
    !!data.receive.pc ||
    !!data.given.pc ||
    // check lab
    !!data.receive.lab ||
    !!data.given.lab ||
    // check bar
    !!data.receive.bar ||
    !!data.given.bar ||
    // check coin
    !!data.receive.coin ||
    !!data.given.coin ||
    // check ginni
    !!data.receive.ginni ||
    !!data.given.ginni ||
    // check silver
    !!data.receive.silver ||
    !!data.given.silver ||
    !!data.receive.goldRateWork ||
    !!data.given.goldRateWork ||
    !!data.receive.silverRateWork ||
    !!data.given.silverRateWork;

  const generateAutoNote = () => {
    const parts = [];

    const pushIf = (condition, text) => {
      if (condition) parts.push(text);
    };

    // ─── RECEIVE ───────────
    pushIf(r_cash?.amount > 0, "Cash received");
    pushIf(r_pc, "PC received");
    pushIf(r_lab, "Lab received");
    pushIf(r_bar, "Bar received");
    pushIf(r_coin, "Coin received");
    pushIf(r_ginni, "Ginni received");
    pushIf(r_silver, "Silver received");
    pushIf(r_goldRateWork, "Gold RW received");
    pushIf(r_silverRateWork, "Silver RW received");

    // ─── GIVEN ───────────
    pushIf(g_cash?.amount > 0, "Cash given");
    pushIf(g_pc, "PC given");
    pushIf(g_lab, "Lab given");
    pushIf(g_bar, "Bar given");
    pushIf(g_coin, "Coin given");
    pushIf(g_ginni, "Ginni given");
    pushIf(g_silver, "Silver given");
    pushIf(g_goldRateWork, "Gold RW given");
    pushIf(g_silverRateWork, "Silver RW given");

    if (parts.length === 0) return "";

    return parts.join(" | ");
  };

  data.note = generateAutoNote();

  if (!customerId) {
    errors.push("Customer is required");
  }

  if (!hasData) {
    errors.push("At least one transaction item is required");
  }

  if (errors && errors.length > 0) {
    return { success: false, errors };
  }

  return {
    success: true,
    data,
  };
};
export const myTransactionRequestUpdpated = ({
  customerId,
  serialNumber,
  receiveTx,
  givenTx,
  note = "",
}) => {
  const errors = [];
  const num = (val) => Number(val || 0);

  const mapCash = (cash) => {
    if (!cash?.amount) return null;
    return { amount: num(cash.amount) };
  };

  const mapPC = (pc) => {
    if (!pc?.transactions?.length) return null;

    return pc.transactions.map((t) => {
      const paidAmount = num(pc.paidAmounts?.[t.id] || 0);

      const isResultBrand = isBrandSelected(t, "pc");
      if (!isResultBrand) errors.push("PC brand is required");

      return {
        brand: t.brand,
        weight: num(t.totalWeight),
        qty: num(t.qty),
        diff: num(t.diff),
        diffAmount: num(t.totalAmount),
        netWeight: num(t.totalWeight),
        netAmount: num(t.totalAmount),
        paidAmount,
      };
    });
  };

  const mapLab = (lab) => {
    if (!lab?.transactions?.length) return null;

    return lab.transactions.map((t) => {
      const paidAmount = num(lab.paidAmounts?.[t.id] || 0);

      return {
        report: t.report ? num(t.report) : null,
        weight: num(t.weight),
        pureWeight: num(t.pureWeight),
        diff: num(t.diff),
        diffAmount: num(t.diffAmount),
        totalAmount: num(t.totalAmount),
        testingFeesPW: num(t.testingPw),
        testingFeesOA: num(t.testingOa),
        testingOaQty: num(t.testingOaQty) || 1,
        resendReport: t.resendReport || false,
        netWeight: num(t.pureWeight),
        netAmount: num(t.totalAmount),
        paidAmount,
      };
    });
  };

  const mapBar = (bar) => {
    if (!bar?.transactions?.length) return null;

    return bar.transactions.map((t) => {
      const paidAmount = num(bar.paidAmounts?.[t.id] || 0);

      const isResultBrand = isBrandSelected(t, "bar");
      if (!isResultBrand) errors.push("Bar brand is required");

      return {
        brand: t.brand,
        barWeight: num(t.weight),
        qty: num(t.qty),
        making: num(t.making),
        totalMaking: num(t.makingTotal),
        totalWeight: num(t.totalWeight),
        totalAmount: num(t.totalAmount),
        discount: num(t.discount),
        diff: num(t.diff),
        netWeight: num(t.totalWeight),
        netAmount: num(t.totalAmount),
        paidAmount,
      };
    });
  };

  // same pattern for coin, ginni, silver...
  const mapCoin = (coin) => {
    if (!coin?.transactions?.length) return null;

    return coin.transactions.map((t) => {
      const paidAmount = num(coin.paidAmounts?.[t.id] || 0);

      const isResultBrand = isBrandSelected(t, "coin");
      if (!isResultBrand) errors.push("Coin brand is required");

      return {
        brand: t.brand,
        coinWeight: num(t.weight),
        qty: num(t.qty),
        making: num(t.making),
        karat: num(t.karat),
        totalWeight: num(t.totalWeight),
        pureWeight: num(t.pureWeight),
        totalAmount: num(t.totalAmount),
        diff: num(t.diff),
        netWeight: num(t.pureWeight || t.totalWeight),
        netAmount: num(t.totalAmount),
        paidAmount,
      };
    });
  };

  const mapGinni = (ginni) => {
    if (!ginni?.transactions?.length) return null;
    return ginni.transactions.map((t) => {
      if (!t?.weight || !t?.totalWeight) return null;
      const isRateApplied = !!t.rate?.rate;
      const netWeight = isRateApplied ? num(t.rate.weight) : num(t.pureWeight);
      const netAmount = num(t.totalAmount || 0);
      const paidAmount = num(ginni.paidAmounts?.[t.id] || 0);
      return {
        ginniWeight: num(t.weight),
        qty: 0,
        refineAmount: num(t.refineAmount),
        refineCharges: num(t.refineCharges),
        report: t.report ? num(t.report) : null,
        isRateApplied,
        rate: getRateOfWork(t, isRateApplied),
        pureWeight: num(t.pureWeight),
        totalAmount: num(t.totalAmount),
        totalWeight: num(t.totalWeight),
        resendReport: t?.resendReport || false,
        paidAmount,
        netWeight,
        netAmount,
      };
    });
  };

  const mapSilver = (silver) => {
    if (!silver?.transactions?.length) return null;
    return silver.transactions.map((t) => {
      if (!t?.totalWeight) return null;
      const isRateApplied = !!t.rate?.rate;
      const netWeight = isRateApplied ? num(t.rate.weight) : num(t.totalWeight);
      const netAmount = num(t.totalAmount || 0);

      const isResultBrand = isBrandSelected(t, "silver");
      if (!isResultBrand) {
        errors.push(`Silver brand is required`);
      }
      const paidAmount = num(silver.paidAmounts?.[t.id] || 0);
      return {
        brand: t.brand,
        barWeight: num(t.barWeight),
        rawalRod: num(t.rawal),
        qty: num(t.qty || 1),
        making: num(t.making),
        isRateApplied,
        rate: getRateOfWork(t, isRateApplied),
        totalWeight: num(t.totalWeight),
        totalAmount: num(t.totalAmount),
        paidAmount,
        netWeight,
        netAmount,
      };
    });
  };

  const mapRateWork = (rw) => {
    if (!rw) return null;
    const weight = num(rw.weight);
    const rate = num(rw.rate);
    if (weight <= 0 || rate <= 0) {
      return null;
    }

    const netAmount = num(rw.totalAmount);
    const netWeight = num(rw.weight);

    //Here i need to check as:
    //status is r then, transaction is completed
    // if status is w, then transaction will be completed after 1 week.
    // if postDate is selected, then, on that date the order will be completed(tx)
    const today = new Date();

    const isCompleted = rw.status === "D&L";
    const completionDate = rw.postDate ? new Date(rw.postDate) : today;

    return {
      weight,
      ...(rw.rate && { rate: num(rw.rate) }),
      ...(rw.amount && { amount: num(rw.amount) }),
      ...(rw.diff && { diff: num(rw.diff) }),
      ...(rw.totalAmount && { totalAmount: num(rw.totalAmount) }),
      ...(rw.status && { status: rw.status }),
      netAmount,
      netWeight,
      postDate: completionDate,
      status: isCompleted ? "D&L" : "Pending",
      isRateApplied: true,
    };
  };
  const r_cash = mapCash(receiveTx?.cash);
  const r_pc = mapPC(receiveTx?.pc);
  const r_lab = mapLab(receiveTx?.lab);
  const r_bar = mapBar(receiveTx?.bar);
  const r_coin = mapCoin(receiveTx?.coin);
  const r_ginni = mapGinni(receiveTx?.ginni);
  const r_silver = mapSilver(receiveTx?.silver);
  const r_goldRateWork = mapRateWork(receiveTx?.goldRW);
  const r_silverRateWork = mapRateWork(receiveTx?.silverRW);

  const g_cash = mapCash(givenTx?.cash);
  const g_pc = mapPC(givenTx?.pc);
  const g_lab = mapLab(givenTx?.lab);
  const g_bar = mapBar(givenTx?.bar);
  const g_coin = mapCoin(givenTx?.coin);
  const g_ginni = mapGinni(givenTx?.ginni);
  const g_silver = mapSilver(givenTx?.silver);
  const g_goldRateWork = mapRateWork(givenTx?.goldRW);
  const g_silverRateWork = mapRateWork(givenTx?.silverRW);

  const data = {
    customerId,
    serialNumber,
    note,

    receive: {
      ...(r_cash != null && { cash: r_cash }),
      ...(r_pc?.length && { pc: r_pc }),
      ...(r_lab?.length && { lab: r_lab }),
      ...(r_bar?.length && { bar: r_bar }),
      ...(r_coin?.length && { coin: r_coin }),
      ...(r_ginni?.length && { ginni: r_ginni }),
      ...(r_silver?.length && { silver: r_silver }),
      ...(r_goldRateWork != null && { goldRateWork: r_goldRateWork }),
      ...(r_silverRateWork != null && { silverRateWork: r_silverRateWork }),
    },

    given: {
      ...(g_cash != null && { cash: g_cash }),
      ...(g_pc?.length && { pc: g_pc }),
      ...(g_lab?.length && { lab: g_lab }),
      ...(g_bar?.length && { bar: g_bar }),
      ...(g_coin?.length && { coin: g_coin }),
      ...(g_ginni?.length && { ginni: g_ginni }),
      ...(g_silver?.length && { silver: g_silver }),
      ...(g_goldRateWork != null && { goldRateWork: g_goldRateWork }),
      ...(g_silverRateWork != null && { silverRateWork: g_silverRateWork }),
    },
  };

  // ─────────────────────────────
  // VALIDATION
  // ─────────────────────────────

  const hasData =
    // check cash amounts
    data.receive.cash?.amount > 0 ||
    data.given.cash?.amount > 0 ||
    // check pc
    !!data.receive.pc?.length ||
    !!data.given.pc?.length ||
    // check lab
    !!data.receive.lab?.length ||
    !!data.given.lab?.length ||
    // check bar
    !!data.receive.bar?.length ||
    !!data.given.bar?.length ||
    // check coin
    !!data.receive.coin?.length ||
    !!data.given.coin?.length ||
    // check ginni
    !!data.receive.ginni?.length ||
    !!data.given.ginni?.length ||
    // check silver
    !!data.receive.silver?.length ||
    !!data.given.silver?.length ||
    !!data.receive.goldRateWork ||
    !!data.given.goldRateWork ||
    !!data.receive.silverRateWork ||
    !!data.given.silverRateWork;

  const generateAutoNote = () => {
    const parts = [];

    const pushIf = (condition, text) => {
      if (condition) parts.push(text);
    };

    // ─── RECEIVE ───────────
    pushIf(r_cash?.amount > 0, "Cash received");
    pushIf(r_pc, "PC received");
    pushIf(r_lab, "Lab received");
    pushIf(r_bar, "Bar received");
    pushIf(r_coin, "Coin received");
    pushIf(r_ginni, "Ginni received");
    pushIf(r_silver, "Silver received");
    pushIf(r_goldRateWork, "Gold RW received");
    pushIf(r_silverRateWork, "Silver RW received");

    // ─── GIVEN ───────────
    pushIf(g_cash?.amount > 0, "Cash given");
    pushIf(g_pc, "PC given");
    pushIf(g_lab, "Lab given");
    pushIf(g_bar, "Bar given");
    pushIf(g_coin, "Coin given");
    pushIf(g_ginni, "Ginni given");
    pushIf(g_silver, "Silver given");
    pushIf(g_goldRateWork, "Gold RW given");
    pushIf(g_silverRateWork, "Silver RW given");

    if (parts.length === 0) return "";

    return parts.join(" | ");
  };

  data.note = generateAutoNote();

  if (!customerId) {
    errors.push("Customer is required");
  }

  if (!hasData) {
    errors.push("At least one transaction item is required");
  }

  if (errors && errors.length > 0) {
    return { success: false, errors };
  }

  return {
    success: true,
    data,
  };
};

export const investmentObject = (investmentData) => {
  const errors = [];

  // Validate partnerId (required)
  if (!investmentData.partnerId) {
    errors.push("partnerId is required.");
  }

  const unit = investmentData.unit === "plzSelect" ? null : investmentData.unit;
  const rate = Number(investmentData.rate) || 0;

  const type =
    investmentData.type !== "plzSelect" ? investmentData?.type : null;
  const amount = Number(investmentData.amount);
  const notes = investmentData.notes || "";
  const dateTime = investmentData.dateTime || new Date().toISOString();

  const requiredObj = {
    partnerId: investmentData.partnerId,
    type,
    amount,
    unit,
    rate,
    notes,
    dateTime,
  };

  if (errors && errors.length > 0) {
    return { errors };
  }

  return { investment: requiredObj };
};

function getRateOfWork(section, isRateApplied = false) {
  return isRateApplied
    ? {
        weight: num(section.rate?.weight),
        rate: num(section.rate.rate),
        diff: num(section.rate?.diff),
        amount: num(section.rate?.amount),
        totalAmount: num(section.rate.totalAmount),
      }
    : null;
}

const requiredItems = ["pc", "bar", "coin", "silver"];
function isBrandSelected(item, itemType) {
  if (requiredItems.includes(itemType)) {
    const brand = item?.brand;
    // console.log({brandValue : })
    if (brand.trim() === "") {
      return false;
    }
    return brand?.toLowerCase() !== "select";
  }
  return true;
}
